const removeItemFromRecursiveArray = (arrayToRemove, itemToRemove, subItemsKey) => {
  if (!arrayToRemove) {
    return arrayToRemove;
  }

  const indexOfItemToRemove = arrayToRemove.indexOf(itemToRemove);

  if (indexOfItemToRemove >= 0) {
    arrayToRemove.splice(indexOfItemToRemove, 1);

    return arrayToRemove;
  }

  arrayToRemove.forEach(item => {
    item[subItemsKey] = removeItemFromRecursiveArray(item[subItemsKey], itemToRemove, subItemsKey);
  });

  return arrayToRemove;
};

export default removeItemFromRecursiveArray;
